
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explorer-advanced",
      function () {
        return require("private-next-pages/explorer-advanced/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explorer-advanced"])
      });
    }
  